<div id="gridContainer">
  @if (validationHistoryLoading()) {
    <mat-progress-bar mode="indeterminate"
                      class="absolute z-50"
    ></mat-progress-bar>
  }

  <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-material"
      [defaultColDef]="defaultColumnDefs"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [rowData]="validationHistory()"
      (gridReady)="onGridReady($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      (rowDataUpdated)="onRowDataUpdated($event)"
  ></ag-grid-angular>

  <div id="actionBarContainer">
    <div class="flex-grow"></div>

    <app-jumper
        [currentItemIndex]="currentRowOneBasedIndex() !== undefined ? currentRowOneBasedIndex() : 0"
        [numberOfItems]="locationTotal() !== undefined ? locationTotal() : 0"
        (currentItemChanged)="changeCurrentRow($event)"
        [showSideArrows]="true">
    </app-jumper>
  </div>

</div>
